// src/api/caseCategory.api.js

import api from './axios';

export const getCaseCategoriesApi = (page = 1, limit = 10, q = '') =>
  api.get('/case/setting/caseCategory', { params: { page, limit, q } });

export const createCaseCategoryApi = (payload) =>
  api.post('/case/setting/caseCategory', payload);

export const updateCaseCategoryApi = (categoryId, payload) =>
  api.put(`/case/setting/caseCategory/${categoryId}`, payload);

export const deleteCaseCategoryApi = (categoryId) =>
  api.delete(`/case/setting/caseCategory/${categoryId}`);
